import { apiHelpers } from './api';
import { Job, ApiResponse, JobFormData } from '../types/models';

export class JobService {
  // Получить должность по ID
  static async getById(id: number): Promise<ApiResponse<Job>> {
    return apiHelpers.get<Job>(`/Job/Get?id=${id}`);
  }

  // Получить все должности (с опциональными фильтрами)
  static async getAll(params?: { departmentId?: number; companyId?: number }): Promise<ApiResponse<Job[]>> {
    const query: string[] = [];
    if (params?.departmentId) query.push(`departmentId=${params.departmentId}`);
    if (params?.companyId) query.push(`companyId=${params.companyId}`);
    const qs = query.length ? `?${query.join('&')}` : '';
    return apiHelpers.get<Job[]>(`/Job/GetAll${qs}`);
  }

  // Получить должности по подразделению
  static async getByDepartment(departmentId: number): Promise<ApiResponse<Job[]>> {
    return JobService.getAll({ departmentId });
  }

  // Получить должности по контрагенту
  static async getByCompany(companyId: number): Promise<ApiResponse<Job[]>> {
    return JobService.getAll({ companyId });
  }

  // Создать новую должность
  static async create(data: JobFormData): Promise<ApiResponse<Job>> {
    return apiHelpers.post<Job>('/Job/Create', data);
  }

  // Обновить должность
  static async update(id: number, data: JobFormData & { id: number }): Promise<ApiResponse<void>> {
    return apiHelpers.put<void>(`/Job/Update/${id}`, data);
  }

  // Удалить должность
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/Job/Delete/${id}`);
  }
}

